<template>
	<div class="BS">
		<div class="BSfirst">
			<div class="BSlogo">
				<div class="svg-lf-logo">
					<SvgIcon svg-name="lfLogo" size="22"></SvgIcon>
				</div>
				<div class="BSlogo-title">
					<div v-for="item in BsTitle" :key="item" class="title-style">
						<div class="svgmore">
							<SvgIcon svg-name="more" size="22"></SvgIcon>
						</div>
						<div class="BStitle" style="line-height: 20px;">{{item}}</div>

					</div>
				</div>
			</div>
			<div class="list">
				<div class="listone">
					<div v-for="(item,i) in titles" :key="i" class="listone-div" :data-name="item.name" :data-path="item.path" @click="openShop">
						{{item.name}}
					</div>
				</div>
				<div class="listtwo">
					<div class="listtwo-div">
						<ul>
							<li v-for="(item,i) in footLeft" :key="i" @click="openProduct(item.name)">{{item.name}}</li>
						</ul>
					</div>
					<div class="listtwo-div">
						<ul>
							<li v-for="item in footCenter" :key="item.name"><a :href="item.url" class="href" target=_blank>{{item.name}}</a></li>

						</ul>
					</div>
					<div class="listtwo-div">
						<ul>
							<li v-for="item in footRight" :key="item">{{item}}</li>
						</ul>
					</div>
					<div class="listtwo-div">
						<div class="herfbill-box"><a href="http://einvoice.lfwellness.com" class="herfbill" target=_blank>电子发票</a></div>
						<ul>
							<li v-for="(item,index) in footRightTo" :key="item" @click="herfBill(index)">{{item}}</li>
						</ul>
					</div>
				</div>


				<div class="BSsvg">


					<div class="svg-weibo">
						<a href="https://weibo.com/leravan?is_hot=1" target=_blank>
							<SvgIcon svg-name="weibo" size="50" @click="change()" class="weibo"></SvgIcon>
						</a>

					</div>

					<div class="svg-flex" @mouseout="changed()" @mouseover="change()">
						<div class="BSimg animated fadeInUp" v-show="isShow">
							<img :src="wechatUrl" alt="">
						</div>
						<div class="wechat">

							<SvgIcon svg-name="wechat" size="50" @click="change()"></SvgIcon>
						</div>
					</div>




				</div>
			</div>
		</div>
		<div class="last">
			Copyright © 2016 - {{systemDate}} LeFan. All Rights Reserved｜厦门乐范健康科技有限公司｜Designed by LF UEDC｜<a  style="color:rgba(135,135,135,1);" href="https://beian.miit.gov.cn">闽ICP备17007620号-1</a>｜
			<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35020602001128" style="color:rgba(135,135,135,1);">
				<img :src="ghimg" alt="">
				闽公网安备 35020602001128号
			</a>




		</div>
	</div>

</template>


<script>
	import SvgIcon from './SvgIcon'
	export default {
		name: 'bottomShow',
		data() {
			return {
				titles: [{
					name: '适用场景',
					path: '/product'
				}, {
					name: '官方网站',
					path: '/shop'
				}, {
					name: '线下渠道',
					path: '/shop'
				}, {
					name: '联系我们',
					path: '/relation'
				}],
				footLeft: [{
					name: '生活更舒适',
				}, {
					name: '出行更轻松',
				}, {
					name: '办公新姿势',
				}],
				footCenter: [{
						name: '天猫旗舰店',
						url: 'https://leravan.tmall.com/?spm=a1z10.3-b-s.w5001-21792119858.2.2f825759flC96i'
					},
					{
						name: '京东旗舰店',
						url: 'https://mall.jd.com/index-715012.html'
					},
					{
						name: '小米有品',
						url: 'https://www.xiaomiyoupin.com/search?keyword=乐范'
					}
				],
				wechatUrl: this.GLOBAL.imgHost + '/images/Floating.png',
				footRight: ['招商信息', '线下授权'],
				footRightTo: ['服务热线：', '400-101-8969', '北京时间：', '周一至周日', '09:00-18:00'],
				apply: 'Copyright © 2016-2020 LeFan. All Rights Reserved｜厦门乐范健康科技有限公司｜Designed by LF UEDC｜闽ICP备17007620号｜',
				isShow: false,
				ghimg: '/images/ghIcon.png',
				systemDate: '',
			}
		},
		props: {
			BsTitle: {
				type: Array,
				default () {
					return []
				}
			}
		},
		created() {
			let nowDate = new Date();
			let date = {
				year: nowDate.getFullYear(),
				month: nowDate.getMonth() + 1,
				date: nowDate.getDate(),
			}
			this.systemDate = date.year;
		},
		methods: {
			openProduct(name) {
				let routeUrl = this.$router.resolve({
					path: "/product",
					query: {
						bottomname: name
					}
				});
				window.open(routeUrl.href, '_self');
			},
			openShop(e) {
				// console.log(e);
				let routeUrl = this.$router.resolve({
					path: e.target.dataset.path,
					query: {
						from: e.target.dataset.name
					}
				});
				window.open(routeUrl.href, '_self');
			},
			change() {
				this.isShow = true
				// console.log(this.isShow)
			},
			changed() {
				this.isShow = false
			}

		},
		components: {
			SvgIcon
		}
	}
</script>

<style scoped>
	.BS {
		display: flex;
		flex-direction: column;
		width: 100%;
		background: rgba(241, 241, 241, 1);

		align-items: center;
	}

	.BSfirst {
		max-width: 1024px;
		border-top: 1px solid rgba(213, 213, 213, 1);
		border-bottom: 1px solid rgba(213, 213, 213, 1);
		width: 100%;
		margin-top: 80px;
		position: relative;
	}

	.BSlogo {
		display: flex;
		margin-top: 15px;
		height: 30px;
		line-height: 30px;
	}

	.BSlogo .svg-lf-logo {
		/* margin-top: 4px; */
	}

	.BSlogo .BSlogo-title {

		/* line-height: 30px; */

		display: flex;
		height: 18px;
		margin-top: 3px;
		width: 300px;
	}

	.BSlogo-title .title-style {
		display: flex;
	}

	.BSlogo-title .svgmore {
		opacity: 0.3;
		margin-left: 13px;
	}

	.BSlogo-title .BStitle {
		margin-left: 13px;

		font-weight: 450;
		color: rgba(85, 85, 85, 1);
		font-size: 16px;

	}

	.list {
		width: 100%;
		margin-right: 15%;

	}

	.listone {
		display: flex;
		color: rgba(54, 54, 54, 1);
		line-height: 20px;

		font-size: 14px;
		padding-top: 25px;
		font-weight: 550
	}

	.listone .listone-div {
		width: 23%;
		text-align: left;
		cursor: pointer;
		font-family: Alibaba-PuHuiTi-M;
	}

	.listtwo {
		display: flex;
		margin-top: 10px;
		font-size: 14px !important;
	}

	.listtwo .listtwo-div {
		width: 23%;
		text-align: left;
	}

	.listtwo .listtwo-div ul {
		padding-inline-start: 0px;
		cursor: pointer;
	}

	.BSsvg {


		display: flex;
		justify-content: flex-end;
		position: relative;
		margin-top: 50px;
		margin-bottom: 20px;
	}

	.BSsvg .svg-flex {
		margin-left: 30px;
	}

	.BSsvg .wechat {
		margin-left: 40px;
		height: 100px;
	}

	.BSsvg .svg-weibo {
		position: relative;
	}

	.weibo {
		position: absolute;

	}

	.BSimg {
		width: 120px;
		height: 140px;

		margin-bottom: 20px;
		position: absolute;
		bottom: 100px;
		right: -18px;
	}

	.BSimg img {
		width: 150px;

	}

	.last {
		max-width: 1024px;

		width: 100%;

		font-size: 12px;

		font-weight: 400;
		color: rgba(135, 135, 135, 1);
		line-height: 33px;
		margin-bottom: 25px;
		text-align: left;

	}

	.list .listtwo-div ul li {
		list-style-type: none;

		margin-right: 10px;
		font-size: 14px;

		font-weight: 400;
		color: rgba(85, 85, 85, 1);
		line-height: 35px;
		margin-top: 5%;
		margin-bottom: 5%;
	}

	.href {

		text-decoration: none;
		color: rgba(85, 85, 85, 1);
	}

	.herfbill-box {
		margin-top: 16px;
		line-height: 30px;
	}

	.herfbill {

		text-decoration: none;
		color: rgba(85, 85, 85, 1);

	}
</style>>
